const checkPwd = () => import('./checkPwd');
const adminEdit = () => import('../power/adminEdit');
const myLog = () => import('./myLog');
const fibSyncLog = () => import('./fibSyncLog');
const remind = () => import('./remind');
const resourcesExport = () => import('./resourcesExport');
const merge = () => import('./merge');
const transfer = () => import('./transfer');
const teacherGroup = () => import('./teacherGroup');
const teacherAllocation = () => import('./teacherAllocation');
const teacherSchedule = () => import('./teacherSchedule');
const channelManage = () => import('@/training/pages/system/channelManage');
const promotionManagement = () => import('@/training/pages/system/promotionManagement');
const toolChannel = () => import('@/training/pages/system/channelTool');
const syncLogList = () => import('@/training/pages/resource/resourceSyncLog');
const channelMapping = () => import('./channelsMapping');
const studyPlanEdit = () => import('./studyPlanEdit');
const timePlanEdit = () => import('./timePlanEdit');
const japanPlanGift = () => import('./japanPlanGift');
const japanPlanAbroad = () => import('./japanPlanAbroad');

const systemRouter = [
  {
    path: '/system/checkPwd', name: 'checkPwd', component: checkPwd, meta: { c: 'system', a: 'checkPwd' }
  },
  {
    path: '/system/account', name: 'account', component: adminEdit, meta: { c: 'system', a: 'account' }
  },
  {
    path: '/system/myLog', name: 'myLog', component: myLog, meta: { c: 'system', a: 'myLog' }
  },
  {
    path: '/system/fibSyncLog', name: 'fibSyncLog', component: fibSyncLog, meta: { c: 'system', a: 'fibSyncLog' }
  },
  {
    path: '/system/remind', name: 'remind', component: remind, meta: { c: 'system', a: 'remind' }
  },
  {
    path: '/system/resourcesExport', name: 'resourcesExport', component: resourcesExport, meta: { c: 'system', a: 'resourcesExport' }
  },
  {
    path: '/system/channels', name: 'channelManage', component: channelManage, meta: { c: 'system', a: 'channels' }
  },
  {
    path: '/system/merge', name: 'merge', component: merge, meta: { c: 'system', a: 'merge' }
  },
  {
    path: '/system/transfer', name: 'transfer', component: transfer, meta: { c: 'system', a: 'transfer' },
  },
  {
    path: '/system/teacherGroup', name: 'teacherGroup', component: teacherGroup, meta: { c: 'system', a: 'teacherGroup' }
  },
  {
    path: '/system/teacherAllocation', name: 'teacherAllocation', component: teacherAllocation, meta: { c: 'system', a: 'teacherAllocation' }
  },
  {
    path: '/system/teacherSchedule', name: 'teacherSchedule', component: teacherSchedule, meta: { c: 'system', a: 'teacherSchedule' }
  },
  {
    path: '/system/promotion', name: 'promotionManagement', component: promotionManagement, meta: { c: 'system', a: 'promotion' }
  },
  {
    path: '/system/toolChannel', name: 'toolChannel', component: toolChannel, meta: { c: 'system', a: 'toolChannel' }
  },
  {
    path: '/system/syncLogList', name: 'syncLogList', component: syncLogList, meta: { c: 'system', a: 'syncLogList' }
  },
  {
    path: '/system/channelMapping', name: 'channelMapping', component: channelMapping, meta: { c: 'system', a: 'channelMapping' }
  },
  {
    path: '/system/studyPlanEdit', name: 'studyPlanEdit', component: studyPlanEdit, meta: { c: 'system', a: 'studyPlanEdit' }
  },
  {
    path: '/system/timePlanEdit', name: 'timePlanEdit', component: timePlanEdit, meta: { c: 'system', a: 'timePlanEdit' }
  },
  {
    path: '/system/japanPlanGift', name: 'japanPlanGift', component: japanPlanGift, meta: { c: 'system', a: 'japanPlanGift' }
  },
  {
    path: '/system/japanPlanAbroad', name: 'japanPlanAbroad', component: japanPlanAbroad, meta: { c: 'system', a: 'japanPlanAbroad' }
  },
];

export default systemRouter;
